import React, { useContext, useEffect, useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { popupcontext } from "../../../context/Popupscontext";
import { Switch } from "antd";
import Button from "../../Helpers/Button/Button";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

export default function CustomerExtra({ addData }) {
	const statusOptions = [
		{ label: trans("Active"), value: true },
		{ label: trans("Inactive"), value: false },
	];
	const [type, setType] = useState("text");
	const [attributes, setAttributes] = useState({
		name: null,
		type: null,
		value: null,
	});
	const { isEditing } = useContext(popupcontext);
	const [shownAttr, setShownAttr] = useState(addData?.values?.customAttributes);
	useEffect(() => {
		if (attributes.type === "boolean") {
			setAttributes((prev) => ({ ...prev, value: false }));
		}
	}, [attributes.type]);
	useEffect(() => {
		addData.setFieldValue(
			"customAttributes",
			shownAttr?.map((i) => {
				return i;
			})
		);
	}, [shownAttr]);

	const handleTypeChange = (e) => {
		setType(e);
		setAttributes((prev) => ({
			...prev,
			type: e,
			value: null, // Reset value when type changes
		}));
	};

	const isDisabled =
		!attributes.name ||
		!attributes.type ||
		attributes.value === null ||
		attributes.value === "";
	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("customer extra info")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Tax Id")}
						type="text"
						placeholder={trans("Enter Tax Id")}
						id="taxId"
						name="taxId"
						formstyle="form-input"
						onBlur={(e) => addData.handleBlur(e)}
						onChange={(e) => addData.handleChange(e)}
						value={addData?.values?.taxId || ""}
						errors={addData?.errors?.taxId}
						touched={addData?.touched?.taxId}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="status"
						name="status"
						id="status"
						options={statusOptions}
						placeholder={trans("Select Status")}
						formstyle="form-input"
						onBlur={(e) => addData.handleBlur(e)}
						onChange={(value) => addData.setFieldValue("status", value)}
						value={
							!addData.values.status ? trans("Inactive") : addData.values.status
						}
						allowClear={false}
					/>
				</div>
				<>
					<div className="d-flex align-items-center">
						<p className="fs-16 fw-500 brand-700 text-capitalize me-2">
							{trans("custom attributes")}
						</p>
						<p style={{ textTransform: "capitalize", color: "#42526E" }}>
							({trans("optional")})
						</p>
					</div>
					<div className="row">
						<div className="col-lg-3">
							<Input
								title={trans("Attribute")}
								type="text"
								placeholder={trans("Enter attribute value")}
								formstyle="form-input"
								onChange={(e) =>
									setAttributes((prev) => ({ ...prev, name: e.target.value }))
								}
								value={attributes.name || ""}
							/>
						</div>
						<div className="col-lg-3">
							<InputSelect
								label="type"
								name="type"
								id="type"
								placeholder={trans("Select type")}
								onChange={handleTypeChange}
								formstyle="form-input"
								options={[
									{ label: trans("Boolean"), value: "boolean" },
									{ label: trans("Text"), value: "text" },
									{ label: trans("Number"), value: "number" },
								]}
								disabled={attributes.name === null}
								value={attributes.type || ""}
							/>
						</div>
						{type !== "boolean" && (
							<div className="col-lg-3">
								<Input
									title={trans("value")}
									type={type}
									placeholder={trans("Enter value")}
									formstyle="form-input"
									onChange={(e) =>
										setAttributes((prev) => ({
											...prev,
											value:
												attributes?.type === "number"
													? Number(e.target.value)
													: e.target.value,
										}))
									}
									value={attributes.value || ""}
								/>
							</div>
						)}
						{type === "boolean" && (
							<div className="col-lg-3">
								<label className="form-label text-capitalize">
									{trans("value")}
								</label>
								<Switch
									style={{ display: "block" }}
									onChange={(e) =>
										setAttributes((prev) => ({
											...prev,
											value: e,
										}))
									}
									checked={!!attributes.value}
								/>
							</div>
						)}
						<div className="col-lg-3">
							<Button
								type="primary"
								icon={<PlusOutlined color="#fff" />}
								text={trans("Add")}
								style={{ transform: "translateY(30px)" }}
								disabled={isDisabled}
								onClick={async () => {
									addData?.values?.customAttributes?.length > 0
										? setShownAttr((prev) => [...prev, attributes])
										: setShownAttr([attributes]);
									setAttributes({
										attribute: null,
										type: null,
										value: null,
									});
								}}
							/>
						</div>
					</div>
					{shownAttr?.length > 0 && (
						<div className="pois-shown-attrs">
							{shownAttr?.map((i, idx) => (
								<div className="poi-shown-attr" key={idx}>
									<div className="poi-attribute-name">
										<div>{i?.name}</div>
									</div>
									<div className="flex-between">
										<div className="poi-attribute-value">
											{i?.type === "boolean"
												? i?.value
													? trans("On")
													: trans("Off")
												: i?.value}
										</div>
										<CloseOutlined
											color="#192839"
											style={{ cursor: "pointer" }}
											onClick={() => {
												setShownAttr((prev) =>
													prev.filter((_, index) => index !== idx)
												);
												setAttributes({
													name: null,
													type: null,
													value: null,
												});
											}}
										/>
									</div>
								</div>
							))}
						</div>
					)}
				</>
			</div>
		</div>
	);
}
